import moment from 'moment';
import { dateFormat } from '../../../../../../constants';
import { getStopApi } from '../../../../../../services/StopApi/StopApi';

export const get2284List = async ({
  commonParams,
  authorization,
  getReportingProgramName,
}) => {
  return await getStopApi({
    commonParams,
    authorization,
  }).then((response) => {
    const json = response.data;
    return {
      isLoading: false,
      total: response.totalRows,
      data: json?.map((item, index) => ({
        ...item,
        id: index,
        epdIrId: item.epdIrId,
        reportingProgramId: getReportingProgramName(item.reportingProgramId),
        reportingProgram: item.reportingProgramId,
        orgAddress: item.orgAddress,
        admitDate: item.admitDate
          ? moment(item.admitDate).format(dateFormat).split('T')[0]
          : null,
      })),
    };
  }).catch((e) => alert(e));
};
